import type { FC, PropsWithChildren } from 'react';

import Top from './Top';

const Layout: FC<PropsWithChildren> = ({ children }) => {
    return (
        <>
            <Top />
            {children}
        </>
    );
};

export default Layout;
